<template>
  <div id="input-form">
    <v-container>
    <v-flex xs12 sm8 md6>
    <p>{{ formTitle }}</p>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        label="Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="address"
        :rules="addressRules"
        label="Address"
        required
      ></v-text-field> 
      <v-text-field
        v-model="property"
        :rules="propertyRules"
        label="Property"
        required
      ></v-text-field>
      <v-menu
          :close-on-content-click="false"
          v-model="menu2"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="computedDateFormatted"
            label="Completed On"
            hint="DD/MM/YYYY"
            persistent-hint
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="completedOn" no-title @input="menu2 = false"></v-date-picker>
          </v-menu><br>
      <!-- <input type="file" @change="onFileChange" id="file" name="file"> -->
      <!-- <div v-if="imageFile">
        <img :src="imageFile" style="max-width:300px;max-height:300px;"/>
        <v-icon @click="removeImage">fa-times</v-icon>
      </div><br> -->
      <v-btn :disabled="!valid" @click="submit" color="primary">{{ buttonName }}</v-btn>
      <v-btn @click="clear" dark>Clear</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="goBack" dark>Back</v-btn>
    </v-form>
    </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'login-form',
  props: ['buttonName', 'editData', 'formTitle'],
  data () {
    return {
      id: null,
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      address: '',
      addressRules: [
        v => !!v || 'Address is required'
      ],
      property: '',
      propertyRules: [
        v => !!v || 'Property is required'
      ],
      completedOn: ''
    }
  },
  beforeMount () {
    if (this.editData) {
      this.id = this.editData.id
      this.name = this.editData.name
      this.address = this.editData.address
      this.property = this.editData.properties
      this.completedOn = this.editData.completed
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'adminUser/getLoggedInUser'
    }),
    computedDateFormatted: function () {
      return this.formatDate(this.completedOn)
    }
  },
  watch: {
    completedOn () {
      this.dateFormatted = this.formatDate(this.completedOn)
    }
  },
  methods: {
    submit () {
      if (!this.editData) {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.id,
            name: this.name,
            address: this.address,
            properties: this.property,
            completed_on: this.computedDateFormatted,
            current_user: this.currentUser
          }
          this.$emit('addItem', data)
        }
      } else {
        if (this.$refs.form.validate()) {
          const data = {
            id: this.id,
            name: this.name,
            address: this.address,
            properties: this.property,
            completed_on: this.computedDateFormatted,
            current_user: this.currentUser
          }
          this.$emit('updateItem', this.editData.id, data)
        }
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    goBack () {
      this.$emit('goBack')
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CompletedDevInputForm.vue